// extracted by mini-css-extract-plugin
module.exports = {"actions__submit":"_19V_Q","actions__facebook":"_2QLqJ","actions__reset-link":"_1JFxx","actions":"_3i-1n"};